import React from "react";

const IconBus = ({ color2="#002970", color = "#fff" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 32 32"
    >
      <g id="Apartment" transform="translate(-472.75 -326)">
        <rect
          id="Rectangle_1782"
          data-name="Rectangle 1782"
          width="32"
          height="32"
          transform="translate(472.75 326)"
          fill="#fff"
          opacity="0"
        ></rect>
        <g
          id="Group_3465"
          data-name="Group 3465"
          transform="translate(347.871 -520.957)"
        >
          <g
            id="Group_737"
            data-name="Group 737"
            transform="translate(126.966 850)"
          >
            <rect
              id="Rectangle_2065"
              data-name="Rectangle 2065"
              width="3"
              height="5"
              rx="1"
              transform="translate(5.914 20.957)"
              fill={color2}
            ></rect>
            <rect
              id="Rectangle_2066"
              data-name="Rectangle 2066"
              width="3"
              height="5"
              rx="1"
              transform="translate(18.914 20.957)"
              fill={color2}
            ></rect>
            <g id="Group_736" data-name="Group 736" transform="translate(0 0)">
              <line
                id="Line_296"
                data-name="Line 296"
                x2="4.454"
                transform="translate(12.421 21.965)"
                fill={color2}
                stroke="#707070"
                stroke-width="2"
              ></line>
              <line
                id="Line_297"
                data-name="Line 297"
                x2="17.155"
                transform="translate(4.502 18.511)"
                fill={color2}
                stroke="#707070"
                stroke-width="2"
              ></line>
              <rect
                id="Rectangle_2062"
                data-name="Rectangle 2062"
                width="22"
                height="23"
                rx="5"
                transform="translate(2.914 -0.043)"
                fill={color}
                stroke={color2}
                stroke-linecap="round"
                stroke-width="2"
              ></rect>
              <path
                id="Rectangle_3079"
                data-name="Rectangle 3079"
                d="M5,0H17a5,5,0,0,1,5,5v8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z"
                transform="translate(2.914 -0.043)"
                fill={color}
                stroke={color2}
                stroke-linecap="round"
                stroke-width="1.8"
              ></path>
              <line
                id="Line_298"
                data-name="Line 298"
                x2="4.638"
                transform="translate(12.055 3.667)"
                fill="none"
                stroke={color2}
                stroke-linecap="round"
                stroke-width="2"
              ></line>
              <path
                id="Path_7493"
                data-name="Path 7493"
                d="M10.937,25.971A1.437,1.437,0,1,1,9.5,24.518,1.445,1.445,0,0,1,10.937,25.971Z"
                transform="translate(-2.786 -7.402)"
                fill={color2}
              ></path>
              <path
                id="Path_7494"
                data-name="Path 7494"
                d="M27.148,25.971a1.437,1.437,0,1,1-1.437-1.453A1.445,1.445,0,0,1,27.148,25.971Z"
                transform="translate(-4.812 -7.402)"
                fill={color2}
              ></path>
              <path
                id="Path_153642"
                data-name="Path 153642"
                d="M-3.275,7.078V4.356H-.467"
                transform="translate(3.275 0.601)"
                fill="none"
                stroke=""
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              ></path>
              <path
                id="Path_153643"
                data-name="Path 153643"
                d="M-.553,7.078V4.356H-3.275"
                transform="translate(28.395 0.601)"
                fill="none"
                stroke={color2}
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default IconBus;
